import { toast } from "@/components/ui/use-toast";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function maskAddress(address: string, maskLength = 6) {
  const len = address.length;
  return `${address.slice(0, 2 + maskLength)}...${address?.slice(
    len - maskLength,
    len,
  )}`;
}

// https://www.w3.org/TR/clipboard-apis/#async-clipboard-api
export async function copyToClipboard(text: string) {
  await window.navigator.clipboard.writeText(text);

  toast({
    title: "Address copied",
    description: "Wallet address copied to clipboard!!",
    variant: "default",
  });
}

export const formatTimestamp = (timestamp: string) =>
  new Date(Number(timestamp) * 1000).toLocaleString("en-IN", {
    day: "numeric",
    month: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

export const handleShare = () => {
  const shareData = {
    title: "P2P.me Merchant",
    text: "🌍 Hey friend! 😄 Guess what? I've jumped on P2P.me Merchant - it's a hassle fully decentralized P2P merchant platform for its fraud free flagship P2P exchange. Seriously, trading's never been this private and easy. You've got to check it out with me and earn some bucks!! 🎉💡",
    url: "https://www.p2p.me/",
  };

  if (navigator.share) {
    navigator
      .share(shareData)
      .then(() => console.log("Successful share"))
      .catch((error) => console.log("Error sharing", error));
  } else {
    navigator.clipboard.writeText(shareData.text);
    toast({
      title: "Share P2P.me merchant app",
      description: "Text copied to clipboard, share it with your friends!",
      variant: "default",
    });
  }
};

export const upiIdDisplay = (qrCode: any) => {
  function isTemporaryUPI(qrCode: string) {
    const hasQRexpire = /QRexpire=[^&]+/.test(qrCode as string);
    const hasAmountOrMode = /am=(\d+(\.\d+)?)/.test(qrCode as string);
    const amountMatch = qrCode.match(/am=(\d+(\.\d+)?)/);
    const amountIsValid = amountMatch && parseFloat(amountMatch[1]) > 0;

    return hasQRexpire || (hasAmountOrMode && amountIsValid);
  }

  let extractedUpi = "";
  let isTemp = false;
  const pattern = /pa=([^&]+)/;
  if (qrCode?.match(pattern)) {
    const qrData = qrCode?.match(pattern);
    extractedUpi = qrData?.[1];
    isTemp = Boolean(isTemporaryUPI(qrCode));
  } else {
    extractedUpi = qrCode;
    isTemp = false;
  }

  return {
    extractedUpi: extractedUpi,
    qrCode: qrCode,
    tempQr: isTemp,
  };
};
